import type { SxProps, Theme } from '@/ui/primitives';

type BuildChartPanelSurfaceSxArgs = {
  width?: number;
  height?: number;
  heightMode?: 'height' | 'minHeight';
  overflowHidden?: boolean;
};

export const buildChartPanelSurfaceSx = ({
  width,
  height,
  heightMode = 'height',
  overflowHidden = true,
}: BuildChartPanelSurfaceSxArgs): Array<
  Exclude<SxProps<Theme>, readonly unknown[] | null | undefined>
> => {
  const sx: Array<Exclude<SxProps<Theme>, readonly unknown[] | null | undefined>> = [
    { backgroundColor: (theme) => `${theme.app.colors.surface} !important` },
  ];

  if (width !== undefined) {
    sx.push({
      width: `${width}px`,
      minWidth: `${width}px`,
      maxWidth: `${width}px`,
    });
  }

  if (height !== undefined) {
    sx.push(
      heightMode === 'minHeight'
        ? { minHeight: `${height}px` }
        : { height: `${height}px`, overflow: overflowHidden ? 'hidden' : undefined },
    );
  }

  return sx;
};
